import Icon from 'components/icons/Icon';
import { IconSymbol } from 'components/icons/Icon.types';

import './Logo.scss';

export type LogoProps = {
  bg?: boolean;
};
export function Logo({ bg = false }: LogoProps) {
  return (
    <Icon
      className="logo"
      symbol={bg ? IconSymbol.logo_w : IconSymbol.logo_g}
    />
  );
}
